module.exports = __webpack_public_path__ + "static/media/Plant_2.de555fcb.svg";